import { useParams } from "react-router-dom";

export const useWorkspaceURL = () => {
  const params = useParams();
  return (path: string) => {
    return `/workspaces/${params.workspace}/${path}`;
  };
};
